import { type MCPServerInfo } from '../../types';

const PlaywrightLocalServer: MCPServerInfo = {
  serverId: 'PLAYWRIGHT_LOCAL',
  name: 'Playwright',
  slug: 'playwright-local',
  description: 'Use playwright to control your browser locally',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    // All config is passed via PLAYWRIGHT_MCP_* env vars, which are the
    // documented alternative to CLI args (https://github.com/microsoft/playwright-mcp).
    // Each env var maps 1:1 to its CLI flag: PLAYWRIGHT_MCP_BROWSER → --browser,
    // PLAYWRIGHT_MCP_HEADLESS → --headless, PLAYWRIGHT_MCP_ALLOWED_ORIGINS → --allowed-origins.
    commandFunction: `(config) => {
  const fs = require('fs');
  const os = require('os');
  const path = require('path');
  // Use a dedicated cwd so Playwright stores its browser profile under ~/.natoma/
  const cwd = path.join(os.homedir(), '.natoma', 'local_connections', 'playwright-local');
  fs.mkdirSync(cwd, { recursive: true });
  return {
    command: 'npx',
    args: ['-y', '@playwright/mcp@latest'],
    env: {
      // browser or chrome channel: chrome (default), firefox, webkit, msedge
      PLAYWRIGHT_MCP_BROWSER: config.browser || 'chrome',
      // run browser in headless mode; headed by default
      ...(config.headless === 'true' ? { PLAYWRIGHT_MCP_HEADLESS: 'true' } : {}),
      // semicolon-separated list of trusted origins the browser may request
      ...(config.allowedOrigins ? { PLAYWRIGHT_MCP_ALLOWED_ORIGINS: config.allowedOrigins } : {})
    },
    cwd
  };
}`
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      browser: {
        type: 'string',
        description:
          'Browser to use for Playwright. Possible values: chrome/chromium/msedge/firefox/webkit',
        sensitive: false,
        default: 'chrome'
      },
      headless: {
        type: 'string',
        description: 'Run browser in headless mode. (true/false)',
        sensitive: false,
        default: 'false'
      },
      allowedOrigins: {
        type: 'string',
        description:
          'Semicolon-separated list of trusted origins the browser is allowed to request (e.g. https://example.com;http://localhost:3000)',
        sensitive: false
      }
    }
  }
};

export default PlaywrightLocalServer;
